import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { MergedDisplayData } from "../types";

interface CreditsAccordionProps {
  displayData: MergedDisplayData;
  isPhotoMaster: boolean;
  isTirage: boolean;
  t: (key: string) => string;
}

export function CreditsAccordion({
  displayData,
  isPhotoMaster,
  isTirage,
  t,
}: CreditsAccordionProps) {
  if (
    !displayData?.oeuvresCreditsCreditOeuvre ||
    !displayData?.oeuvresCreditsCreditPhotoOeuvre ||
    isPhotoMaster ||
    isTirage
  ) {
    return null;
  }

  return (
    <AccordionItem value="credits">
      <AccordionTrigger>{t("singleArtworkSubtitleCredits")}</AccordionTrigger>
      <AccordionContent>
        <p>
          {displayData.oeuvresCreditsCreditOeuvre} |{" "}
          {displayData.oeuvresCreditsCreditPhotoOeuvre}
        </p>
      </AccordionContent>
    </AccordionItem>
  );
}

